import React from "react";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { Box, Chip, Container, Divider, Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBullhorn,
    faCheckCircle,
    faPeopleGroup,
    faUser,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";

// @ts-ignore
import imgJpg from "../../assets/images/others/jpg-5.png";
// @ts-ignore
import imgGroup from "../../assets/images/others/photo-vld-groupe.jpeg";

const colistiers = [
    "1. Jean-Philippe Guibert - Photographe, ancien adjoint aux affaires scolaires et périscolaires",
    "2. Laurence Gravier - Notaire",
    "3. Cyril Parussolo - Manager opérationnel informatique",
    "4. Cécile Faragoni - Cheffe de service ingénierie eau potable",
    "5. Fabrice Martinez - Dirigeant de société",
    "6. Charlotte Gachon - Comédienne",
    "7. Xavier Blondaz-Gérard - Responsable Marketing",
    "8. Laurence Chammah - Greffier principal",
    "9. Philippe Lefort - Retraité du ministère de l'intérieur",
    "10. Séverine Gopauloo - Directrice d'agence bancaire à la retraite",
    "11. Jean-Pierre Morin - Cadre dirigeant",
    "12. Clarisse Perret - Responsable formation / marketing en pré retraite",
    "13. Paul Walther - Consultant finances",
    "14. Madison Détré - Étudiante en journalisme",
    "15. Cyril Lamirand - Ingénieur informatique",
    "16. Jacqueline Megret-Petit - Retraitée de l'Éducation Nationale",
    "17. Jean-Jacques Van Poucke - Chef d'entreprise plomberie (retraité)",
    "18. Isabelle Lacoste - Infirmière à la retraite",
    "19. François Perret - Responsable de projets informatiques à la retraite",
    "20. Stéphanie Cornette - Enseignante",
    "21. Cyril Radici - Directeur Général d'une Organisation Professionnelle",
    "22. Fabienne Vier - Comptable et aide familiale",
    "23. Mayeul Buisson - Responsable qualité",
    "24. Anne Sophie Jacouty - Ecrivain",
    "25. François Dugain - Retraité (Conducteur de travaux)",
    "26. Babeth Aloy - Photojournaliste",
    "27. Stéphane Beix - Commercial",
    "28. Sylvie Carrier - Retraitée (responsable RH)",
    "29. Stéphane Kidjo - Entrepreneur solution IA",
    "30. Stéphanie Diot - Responsable service ingénieurs aéronautiques",
    "31. François Bonnin - Directeur Financier",
];

const POST20260306: React.FC = () => {
    const middle = Math.ceil(colistiers.length / 2);
    const colistiersLeft = colistiers.slice(0, middle);
    const colistiersRight = colistiers.slice(middle);
    const parseColistier = (item: string) => {
        const match = item.match(/^(\d+)\.\s*(.*)$/);
        if (!match) return { number: "", text: item };
        return { number: match[1], text: match[2] };
    };

    return (
        <Container maxWidth="lg" sx={{ mb: 8 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />

            <Box mt={3} mb={5}>
                <Typography variant="h6" fontWeight={700} align="center" gutterBottom color="primary">
                    <FontAwesomeIcon icon={faBullhorn} style={{ marginRight: 8 }} />
                    VLD2026 - Circulaire de profession de foi (6&nbsp;mars&nbsp;2026)
                </Typography>
                <Divider sx={{ mt: 1, mb: 3 }} />
            </Box>

            <Stack spacing={5}>
                <Paper
                    elevation={4}
                    sx={{
                        p: { xs: 3, md: 4 },
                        borderRadius: 4,
                        border: "1px solid rgba(25,118,210,0.14)",
                        background:
                            "linear-gradient(135deg, rgba(13,71,161,0.06) 0%, rgba(25,118,210,0.03) 55%, rgba(67,160,71,0.05) 100%)",
                    }}
                >
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
                        <Chip icon={<FontAwesomeIcon icon={faUsers} />} label="Profession de foi" sx={{ fontWeight: 700 }} />
                        <Chip icon={<FontAwesomeIcon icon={faPeopleGroup} />} label="Équipe complète" sx={{ fontWeight: 700 }} />
                    </Stack>

                    <Typography variant="h4" fontWeight={900} color="#0d47a1" sx={{ mb: 2 }}>
                        Circulaire de profession de foi
                    </Typography>

                    <Grid container spacing={2.2} alignItems="stretch">
                        <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
                            <Paper elevation={0} sx={{ p: 1.5, borderRadius: 3, border: "1px solid #e0e0e0", width: "100%" }}>
                                <Box
                                    component="img"
                                    src={imgJpg}
                                    alt="Jean-Phillipe GUIBERT"
                                    sx={{
                                        width: "100%",
                                        height: { xs: 320, md: 360 },
                                        objectFit: "cover",
                                        objectPosition: "50% 16%",
                                        borderRadius: 2,
                                        display: "block",
                                    }}
                                />
                                <Typography variant="subtitle1" align="center" fontWeight={900} sx={{ mt: 1.2 }}>
                                    Jean-Phillipe GUIBERT, tête de liste de Vivre la démocratie 2026
                                </Typography>
                            </Paper>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
                            <Paper elevation={0} sx={{ p: 1.5, borderRadius: 3, border: "1px solid #e0e0e0", width: "100%" }}>
                                <Box
                                    component="img"
                                    src={imgGroup}
                                    alt="Photo du Groupe VLD 2026"
                                    sx={{
                                        width: "100%",
                                        height: { xs: 320, md: 360 },
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        borderRadius: 2,
                                        display: "block",
                                    }}
                                />
                                <Typography variant="subtitle1" align="center" fontWeight={900} sx={{ mt: 1.2 }}>
                                    Photo du Groupe
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>

                    <Paper
                        elevation={0}
                        sx={{
                            mt: 2.2,
                            p: 2,
                            borderRadius: 3,
                            bgcolor: "#e8f5e9",
                            border: "1px solid rgba(67,160,71,0.25)",
                        }}
                    >
                        <Typography variant="h6" fontWeight={900} color="#2e7d32">
                            Protéger notre qualité de vie, c'est préserver notre identité de village en forêt, protéger votre patrimoine, sécuriser votre quotidien et vous garantir des services communaux de qualité.
                        </Typography>
                    </Paper>
                </Paper>

                <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, borderRadius: 4, borderLeft: "6px solid #1565c0" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                        <FontAwesomeIcon icon={faPeopleGroup} style={{ color: "#1565c0" }} />
                        <Typography variant="h5" fontWeight={900} color="#1565c0">
                            Liste des collistiers
                        </Typography>
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: "#f8fbff", border: "1px solid rgba(21,101,192,0.16)" }}>
                                <Stack spacing={0.7}>
                                    {colistiersLeft.map((item) => (
                                        <Box
                                            key={item}
                                            sx={{
                                                display: "flex",
                                                gap: 1.2,
                                                alignItems: "flex-start",
                                                py: 0.8,
                                                borderBottom: "1px dashed rgba(21,101,192,0.2)",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: "50%",
                                                    bgcolor: "#1565c0",
                                                    color: "white",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    fontSize: "0.76rem",
                                                    fontWeight: 900,
                                                    flex: "0 0 auto",
                                                    mt: "2px",
                                                }}
                                            >
                                                {parseColistier(item).number}
                                            </Box>
                                            <Box
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: "50%",
                                                    bgcolor: "rgba(21,101,192,0.12)",
                                                    color: "#1565c0",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    flex: "0 0 auto",
                                                    mt: "4px",
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faUser} style={{ fontSize: 11 }} />
                                            </Box>
                                            <Typography variant="body2" sx={{ lineHeight: 1.6, pt: "1px" }}>
                                                {parseColistier(item).text}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Paper>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: "#f8fbff", border: "1px solid rgba(21,101,192,0.16)" }}>
                                <Stack spacing={0.7}>
                                    {colistiersRight.map((item) => (
                                        <Box
                                            key={item}
                                            sx={{
                                                display: "flex",
                                                gap: 1.2,
                                                alignItems: "flex-start",
                                                py: 0.8,
                                                borderBottom: "1px dashed rgba(21,101,192,0.2)",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: "50%",
                                                    bgcolor: "#1565c0",
                                                    color: "white",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    fontSize: "0.76rem",
                                                    fontWeight: 900,
                                                    flex: "0 0 auto",
                                                    mt: "2px",
                                                }}
                                            >
                                                {parseColistier(item).number}
                                            </Box>
                                            <Box
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: "50%",
                                                    bgcolor: "rgba(21,101,192,0.12)",
                                                    color: "#1565c0",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    flex: "0 0 auto",
                                                    mt: "4px",
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faUser} style={{ fontSize: 11 }} />
                                            </Box>
                                            <Typography variant="body2" sx={{ lineHeight: 1.6, pt: "1px" }}>
                                                {parseColistier(item).text}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, borderRadius: 4 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                        <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#2e7d32" }} />
                        <Typography variant="h5" fontWeight={900} color="#2e7d32">
                            Chères Bacottes, Chers Bacots
                        </Typography>
                    </Stack>

                    <Stack spacing={2}>
                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Les 15 et 22 mars, vous choisirez l'avenir de Bois-le-Roi. Votre vote permettra de tourner une page et d'engager notre commune sur une trajectoire de confiance, de fierté et d'unité.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Bois-le-Roi dispose d'atouts exceptionnels un cadre naturel préservé, un patrimoine riche, une vie associative dynamique et des commerces de proximité. Mais, comme vous savez, Bois-le-Roi traverse un moment décisif. Finances dégradées, investissements structurants différés (crèche, équipements sportifs et culturels), PLUi à modifier et une obligation de réaliser de nombreux logements sociaux (loi SRU) : les signaux d'alerte s'accumulent et notre qualité de vie est en jeu.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Il est urgent de changer de cap pour préserver l'équilibre de notre commune et garantir un avenir maîtrisé à toutes les familles bacottes. Nous devons pouvoir continuer à faire société à Bois-le-Roi. Toutes et tous. Notre commune doit défendre clairement son identité et ses intérêts, tout en mettant fin à la dérive des dépenses et de l'endettement. Avec mon équipe, nous nous engageons à restaurer une gestion rigoureuse, à stopper l'augmentation des charges et à retrouver une capacité d'investissement, sans hausse d'impôts,
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Préserver notre cadre de vie est notre priorité. Nous modifierons le PLUi pour protéger notre identité de village en forêt : sanctuarisation du Bois de la Source, suppression des Secteurs de Mixité Sociale de type 2. Nous améliorerons l'entretien de la commune et la collecte des déchets verts en augmentant le nombre de passages annuels.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Nous porterons des projets concrets: sauvegarde de l'église et valorisation du patrimoine, rééquilibrage des mobilités entre piétons, vélos et voitures, amélioration de la voirie, optimisation de l'éclairage public pour concilier le besoin de sécurité et la protection de la biodiversité.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Nous conduirons une transition écologique pragmatique. Cela passe par la protection des espaces boisés, l'anticipation des risques climatiques et hydrogéologiques, et la maîtrise des dépenses énergétiques.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Nous œuvrerons au sein de l'agglomération pour une eau de qualité, sans perchlorates ni pesticides, avec publication transparente des analyses.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Nous mettrons toute notre énergie pour installer les médecins généralistes qui manquent à la commune.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            La sécurité est non négociable: restauration de la sérénité entre la gare et l'Île de Loisirs en période estivale, prévention active des cambriolages, participation renforcée à la Commission intercommunale de sécurité et soutien à la création d'un bureau de Police nationale sur l'île de Loisirs.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            L'enfance sera au cœur de notre action implantation d'une mini-crèche privée près des écoles sur un site déjà artificialisé, amélioration de la restauration scolaire. Nous renforcerons l'attractivité de la commune par la culture et augmenterons les capacités d'accueil sportives.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Enfin, nous consoliderons la solidarité locale et l'exigence démocratique lutte contre l'isolement, soutien aux seniors et aux familles, prise en compte de l'accessibilité dans chacun de nos projets, soutien actif à nos commerçants et professionnels, consultation en amont des décisions et réunion publique annuelle sur les finances.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Je sais où je veux conduire notre commune et j'ai une vision claire du Bois-le-Roi de demain. Protéger notre qualité de vie, c'est préserver notre identité de village en forêt, protéger votre patrimoine, sécuriser votre quotidien et vous garantir des services communaux de qualité.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                            Le chemin sera exigeant, mais nous le ferons ensemble, et je resterai fidèle à cette ligne de conduite.
                        </Typography>
                    </Stack>
                </Paper>
            </Stack>
        </Container>
    );
};

export default POST20260306;
